export default {"src":"/_next/static/media/fact_star.8db55b79.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};